<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog custom-dialog customerEDIInfo"
    :style="$cookies.get('comp-id') === $cookies.get('ownr-id') ? 'width: 650px !important;' : ''"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title>{{
        options.item.action + ' ' + $t('lbl.aiClient.aiClient')
      }}</v-card-title>
    </template>
    <template v-slot:button-close>
      <!-- <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="v-dialog-1">
      <!-- [S]  Popup body-->
      <v-card-text class="pa-0 pt-5">
        <v-row>
          <v-col cols="12">
            <v-form ref="form" class="dialog-content form-filter">
              <v-row class="ml-0 mr-0 mb-1">
                <v-col cols="12" class="pa-0">
                  <v-label>
                    <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                    {{ $t('lbl.aiClient.aiClientName') }}
                  </v-label>
                  <v-text-field
                    ref="aiClientName"
                    v-model="formData.aiNm"
                    :rules="[validationUtils.required]"
                    :disabled="!$auth.manage || formData.action === 'Edit'"
                    :class="[formData.action == 'Edit' ? 'name-input-disable' : '']"
                    heigth="30"
                    :maxlength="100"
                    solo
                    @blur="validateAIClientName()"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0 mb-1">
                <v-col cols="12" class="pa-0">
                  <v-label>
                    <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                    {{ $t('lbl.aiClient.type') }}
                  </v-label>
                  <v-autocomplete
                    v-model="formData.aiTp"
                    :rules="[validationUtils.required]"
                    :items="aiTpCdList"
                    :disabled="!$auth.manage"
                    class="custom-selectbox"
                    height="30"
                    solo
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0 mb-1">
                <v-col lg="12" class="pa-0">
                  <v-label>
                    <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                    {{ $t('lbl.aiClient.apiEndpoint') }}
                  </v-label>
                  <v-text-field
                    v-model="formData.aiEndpoint"
                    :rules="[validationUtils.required]"
                    :disabled="!$auth.manage"
                    :maxlength="200"
                    solo
                    heigth="30"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col lg="12" class="pt-0">
                  <v-label>
                    <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                    {{ $t('lbl.aiClient.apiFormData') }}
                  </v-label>
                  <v-icon class="ml-1" @click="addFormData()" :disabled="!$auth.manage" dense dark
                    >mdi-plus</v-icon
                  >
                </v-col>
                <v-col cols="12" md="12" class="px-3 pb-4 pt-0">
                  <v-row
                    class="pt-0 pt-0 pb-1 edi-identification-right"
                    v-for="(item, i) in formData.listFormData"
                    :key="item.id"
                  >
                    <v-col lg="4" class="pl-3 pr-2 py-0">
                      <v-text-field
                        :ref="'FD_' + item.id"
                        :maxlength="200"
                        solo
                        hide-details
                        placeholder="Key"
                        :disabled="!$auth.manage"
                        v-model="item.key"
                      ></v-text-field>
                    </v-col>
                    <v-col lg="7" class="pl-2 pr-2 py-0">
                      <v-text-field
                        :ref="'FD_' + item.id + '_' + item.id"
                        :maxlength="200"
                        solo
                        hide-details
                        placeholder="Value"
                        :disabled="!$auth.manage"
                        v-model="item.value"
                      ></v-text-field>
                    </v-col>
                    <v-col lg="1" class="pa-0 pr-3 mr-0 mt-2">
                      <v-icon
                        @click="removeFormData(i)"
                        :disabled="!$auth.manage"
                        dense
                        class="ml-1"
                        dark
                        >mdi-minus</v-icon
                      >
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" class="pl-3 pr-0 py-0 mb-4">
                  <v-label>
                    <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                    {{ $t('lbl.aiClient.apiHeader') }}
                    <v-icon class="ml-1" @click="addHeader()" :disabled="!$auth.manage" dense dark
                      >mdi-plus</v-icon
                    >
                  </v-label>
                </v-col>
                <v-col cols="12" md="12" class="px-3 pb-4 pt-0">
                  <v-row
                    class="pt-0 pt-0 pb-1 edi-identification-right"
                    v-for="(item, i) in formData.listHeader"
                    :key="item.id"
                  >
                    <v-col lg="4" class="pl-3 pr-2 py-0">
                      <v-text-field
                        :ref="'HEADER_' + item.id"
                        :maxlength="200"
                        solo
                        hide-details
                        placeholder="Key"
                        :disabled="!$auth.manage"
                        v-model="item.key"
                      ></v-text-field>
                    </v-col>
                    <v-col lg="7" class="pl-2 pr-2 py-0">
                      <v-text-field
                        :ref="'HEADER_' + item.id + '_' + item.id"
                        :maxlength="200"
                        solo
                        hide-details
                        placeholder="Value"
                        :disabled="!$auth.manage"
                        v-model="item.value"
                      ></v-text-field>
                    </v-col>
                    <v-col lg="1" class="pa-0 pr-3 mr-0 mt-2">
                      <v-icon
                        @click="removeHeader(i)"
                        :disabled="!$auth.manage"
                        dense
                        class="ml-1"
                        dark
                        >mdi-minus</v-icon
                      >
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0 mb-1">
                <v-col lg="12" class="pa-0">
                  <v-label>
                    <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                    {{ $t('lbl.aiClient.dataPathOfAPIResult') }}
                  </v-label>
                  <v-text-field
                    v-model="formData.aiFooter"
                    :rules="[validationUtils.required]"
                    :disabled="!$auth.manage"
                    solo
                    :maxlength="200"
                    heigth="30"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
        <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
        <v-row class="ml-0 mr-0">
          <v-col class="button-col action-col" lg="12">
            <div class="btn-form-control text-right">
              <v-btn class="btn btn-delete btn-popup" @click="removeDialog">
                {{ $t('btn.common.close') }}
              </v-btn>
              <v-btn
                class="btn btn-popup-search btn-popup"
                color="primary"
                @click="onSave"
                :disabled="!$auth.manage"
              >
                {{ $t('btn.common.save') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <dialogWindow
        ref="messageDialog"
        size="max"
        :info="checkDialogTitle"
        :detail="checkDialogInfo"
        :color="checkDialogColor"
        @select-ok="removeMessageDialog()"
      ></dialogWindow>
    </v-card>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag2.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg,
  },
  name: 'add-ai-client-dialog',
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    refeshList: Function,
    aiTpCdList: Array,
  },
  data() {
    return {
      formData: {
        aiId: '',
        aiNm: '',
        aiTp: '',
        listUserData: [],
        listFormData: [],
        listHeader: [],
        aiEndpoint: '',
        aiFooter: '',
        aiFormData: '',
        aiHeader: '',
      },

      checkDialogTitle: '',
      checkDialogColor: 'warning',
      checkDialogInfo: '',
    };
  },
  methods: {
    validateAIClientName() {
      const isDuplicate = this.aiClientList.some(
        (e) => e.aiNm === this.formData.aiNm && e.aiId !== this.formData.aiId
      );
      if (isDuplicate) {
        this.checkDialogInfo = `AI Client name : ${this.formData.aiNm} have been created !`;
        this.checkDialogColor = 'warning';
        this.$refs.messageDialog.dialog = true;
        this.formData.aiNm = '';
        return false;
      }
      return true;
    },
    addFormData() {
      let i =
        this.formData.listFormData.length > 0
          ? this.formData.listFormData[this.formData.listFormData.length - 1].id + 1
          : 1;
      let obj = {
        id: i,
        key: '',
        value: '',
      };
      this.formData.listFormData.push(obj);
    },
    addHeader() {
      let i =
        this.formData.listHeader.length > 0
          ? this.formData.listHeader[this.formData.listHeader.length - 1].id + 1
          : 1;
      let obj = {
        id: i,
        key: '',
        value: '',
      };
      this.formData.listHeader.push(obj);
    },
    removeFormData(i) {
      this.formData.listFormData.splice(i, 1);
    },
    removeHeader(i) {
      this.formData.listHeader.splice(i, 1);
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.aiClientName.focus();
      }, 300);
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    removeMessageDialog() {
      this.$refs.messageDialog.dialog = false;
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },

    async onSave() {
      let validResult = this.$refs.form.validate();
      if (!validResult) return;
      if (!this.validateAIClientName()) return;

      if (this.formData.listFormData.length === 0) {
        this.$refs.messageDialog.dialog = true;
        this.checkDialogColor = 'warning';
        this.checkDialogInfo = 'Please insert Form Data (at least one)';
        return;
      } else if (this.formData.listHeader.length === 0) {
        this.$refs.messageDialog.dialog = true;
        this.checkDialogColor = 'warning';
        this.checkDialogInfo = 'Please insert Header (at least one)';
        return;
      }

      this.formData.aiFormData = '';
      if (this.formData.listFormData.length > 0) {
        let num = this.formData.listFormData.findIndex(
          (e) => !e.key.replace(/\s/g, '').length || !e.value.replace(/\s/g, '').length
        );
        if (num > -1) {
          this.hideItem = false;
          let index = this.formData.listFormData[num];
          return this.$refs[
            `FD_${index.id}${!index.key.replace(/\s/g, '').length ? '' : '_' + index.id}`
          ][0].focus();
        }

        let arrChk = this.formData.listFormData.map((e) => {
          return e.key + e.value;
        });
        let isDuplicate = arrChk.findIndex((e, i) => {
          return arrChk.indexOf(e) != i;
        });

        if (isDuplicate > -1) {
          this.$refs.messageDialog.dialog = true;
          this.checkDialogColor = 'warning';
          this.checkDialogInfo = 'Duplicate form data.';
          return;
        }

        let aiFormData = '';
        this.formData.listFormData.map((e) => {
          aiFormData += `"${e.key}","${e.value}",`;
        });

        aiFormData = aiFormData.slice(0, aiFormData.length - 1);

        if (aiFormData.length > 200) {
          this.$refs.messageDialog.dialog = true;
          this.checkDialogColor = 'warning';
          this.checkDialogInfo = 'Max length of API Form Data is 200 characters ';
          return;
        }
        this.formData.aiFormData = aiFormData;
      }

      this.formData.aiHeader = '';
      if (this.formData.listHeader.length > 0) {
        let num = this.formData.listHeader.findIndex(
          (e) => !e.key.replace(/\s/g, '').length || !e.value.replace(/\s/g, '').length
        );
        if (num > -1) {
          this.hideItem = false;
          let index = this.formData.listHeader[num];
          return this.$refs[
            `HEADER_${index.id}${!index.key.replace(/\s/g, '').length ? '' : '_' + index.id}`
          ][0].focus();
        }

        let arrChk = this.formData.listHeader.map((e) => {
          return e.key + e.value;
        });
        let isDuplicate = arrChk.findIndex((e, i) => {
          return arrChk.indexOf(e) != i;
        });

        if (isDuplicate > -1) {
          this.$refs.messageDialog.dialog = true;
          this.checkDialogColor = 'warning';
          this.checkDialogInfo = 'Duplicate form data.';
          return;
        }

        let aiHeader = '';
        this.formData.listHeader.map((e) => {
          aiHeader += `"${e.key}","${e.value}",`;
        });

        aiHeader = aiHeader.slice(0, aiHeader.length - 1);

        if (aiHeader.length > 200) {
          this.$refs.messageDialog.dialog = true;
          this.checkDialogColor = 'warning';
          this.checkDialogInfo = 'Max length of API Form Data is 200 characters ';
          return;
        }
        this.formData.aiHeader = aiHeader;
      }
      if (this.options.item.action == 'Edit') {
        this.formData.byProcSetup = false;
        this.$store
          .dispatch('editAIClient', this.formData)
          .then(() => {
            this.refeshList();
            this.removeDialog({});
          })
          .catch((ex) => {
            this.checkDialogColor = 'error';
            this.checkDialogInfo = this.$t('msg.aiClient.errorSave');
            this.$refs.messageDialog.dialog = true;
          });
      } else {
        this.$store
          .dispatch('insertAIClient', this.formData)
          .then(() => {
            this.refeshList();
            this.removeDialog({});
          })
          .catch((ex) => {
            this.checkDialogColor = 'error';
            this.checkDialogInfo = this.$t('msg.aiClient.errorSave');
            this.$refs.messageDialog.dialog = true;
          });
      }
    },
    async initialize() {
      this.$store.dispatch('getAIClientSelectBoxList');

      if (this.options.item.action != 'Add') {
        this.formData = this.options.item.data;
        await this.$store
          .dispatch('getAIClientDetail', this.options.item.data.aiId)
          .then(() => {
            let data = this.$store.getters.aiClientDetail;
            data.listFormData = [];
            data.listHeader = [];

            if (data.aiFormData !== '') {
              let arrFormData = data.aiFormData.replace(/"/g, '').split(',');
              for (let j = 0; j < arrFormData.length; j += 2) {
                data.listFormData.push({
                  id: j / 2,
                  key: arrFormData[j],
                  value: arrFormData[j + 1],
                });
              }
            }

            if (data.aiHeader !== '') {
              let arrHeader = data.aiHeader.replace(/"/g, '').split(',');
              for (let j = 0; j < arrHeader.length; j += 2) {
                data.listHeader.push({
                  id: j / 2,
                  key: arrHeader[j],
                  value: arrHeader[j + 1],
                });
              }
            }
            this.formData = Object.assign({}, data);
            if (this.options.item.action == 'Copy') {
              this.formData.aiNm = '';
              this.formData.aiId = '';
            }
          })
          .catch((ex) => {});
      } else {
        this.setFocus();
      }
    },
  },

  created() {
    this.initialize();
  },
  computed: {
    aiClientList() {
      return this.$store.getters.aiClientSelectBoxList;
    },
  },
};
</script>

<style></style>
